import { ContentLayout } from "components/generic";
import GisPageAssignmentTab from "tabs/gispageassignmenttab";
import GisPageTreeTab from "tabs/gispagetreetab";
import { useIntl } from "react-intl";
import GisLayerMaster from "tabs/gislayermaster";

const GisPage = () => {
    const intl = useIntl();

    const tabs: any[] = [
        {
            id: "assignments",
            title: `${intl.formatMessage({ id: "app.gis.assignments" })}`,
            content: () => <GisPageAssignmentTab />,
        },
        {
            id: "tree-structure",
            title: `${intl.formatMessage({ id: "app.gis.tree_structure" })}`,
            content: () => <GisPageTreeTab />,
        },
        {
            id: "layer-master",
            title: `${intl.formatMessage({ id: "app.gis.layer_master" })}`,
            content: () => <GisLayerMaster />,
        },
    ];

    return (
        <ContentLayout
            title={`${intl.formatMessage({ id: "app.gis.title" })}`}
            tabs={tabs}
            showTabs={true}
        />
    );
};

export default GisPage;
